export function handleExpiredLogin(error) {
    // redirect... for now
    const loginUrl = error.loginUrl;
    setTimeout(() => {
        window.location.href = loginUrl;
    }, 2500);
}
//# sourceMappingURL=handlers.js.map